
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { RawLocation } from 'vue-router';
import TrashIcon from '@/assets/svg/trash-opaque.vue.svg';
import BravadoIconButton from '~/components/common/BravadoIconButton/BravadoIconButton.vue';
import { getTestimonialApprovalRoute } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/utils';
import { testimonialStates } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/constants';
import type { TestimonialState } from '~/types/graphql';

export default Vue.extend({
  name: 'ActionNeededTestimonial',
  components: { BravadoIconButton, TrashIcon },
  props: {
    authorName: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorEmail: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonial: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonialId: {
      type: String,
      required: true,
    } as PropOptions<string>,
    state: {
      type: String,
      required: true,
    } as PropOptions<TestimonialState>,
    slug: {
      type: String,
      required: true,
    } as PropOptions<string>,
  },
  computed: {
    dotClass(): Record<string, boolean> {
      return {
        'le-dot': true,
        'le-dot--alert': this.isAlert,
      };
    },
    isAlert(): boolean {
      return testimonialStates.FAILED_TESTIMONIAL_STATES.includes(this.state);
    },
    testimonialApprovalRoute(): RawLocation {
      return getTestimonialApprovalRoute(this.slug, this.testimonialId);
    },
  },
});
